import { Asset, AssetType } from '../types/config';

export const topGalleryUrls = (assets: Asset[]) => {
  if (!assets) return [];

  const gallery: Asset[] = [];
  let urls: string[] = [];

  for (const a of assets) {
    if (
      // assets that have a polygonId are part of Inventory and not part of the top gallery
      !a.polygonId &&
      (a.type === AssetType.Gallery || a.type === AssetType.MainImage || a.type === AssetType.Video)
    ) {
      gallery.push(a);
    }
  }

  if (gallery.length) {
    gallery.sort((a, b) => a.order - b.order);
    urls = gallery.map((asset) => asset.url);
  }

  return urls;
};
